// Generated by scripts/login_captcha/emit.mjs; edit the TypeScript source.
import { asCaptchaToken, LOCAL_PROOF_TTL_MS } from '../policies/index.js';
import { loadCaptchaSdk } from './sdk.store.js';
// WAF owns verification. This session only coordinates automatic browser proof.
export function createCaptchaSession(config, publish, loadSdk = loadCaptchaSdk, now = Date.now) {
    let disposed = false, consumed = false, failed = false;
    let proof = null, sdk = null;
    let expiresAt = 0;
    let timer;
    let cancelRefresh;
    const expire = (state) => {
        if (disposed)
            return;
        clearTimeout(timer);
        proof = null;
        failed = true;
        publish(state);
    };
    publish('loading');
    timer = setTimeout(() => expire('error'), 20000);
    void loadSdk(config.scriptUrl).then(async (loaded) => {
        if (disposed || failed)
            return;
        sdk = loaded;
        const token = await sdk.getToken();
        if (disposed || failed)
            return;
        proof = asCaptchaToken(token);
        if (!proof) {
            expire('error');
            return;
        }
        clearTimeout(timer);
        expiresAt = now() + LOCAL_PROOF_TTL_MS;
        timer = setTimeout(() => expire('expired'), LOCAL_PROOF_TTL_MS);
        publish('verified');
    }).catch(() => expire('error'));
    return {
        async consume() {
            if (disposed || consumed || failed || !proof || !sdk || now() >= expiresAt) {
                if (proof && !consumed)
                    expire('expired');
                return null;
            }
            consumed = true;
            proof = null;
            clearTimeout(timer);
            publish('submitting');
            // Refresh immediately before POST; never automatically retry the login.
            try {
                const timeout = new Promise((_, reject) => {
                    cancelRefresh = () => reject(new Error('Challenge disposed'));
                    timer = setTimeout(() => reject(new Error('Challenge timeout')), 5000);
                });
                const token = asCaptchaToken(await Promise.race([sdk.getToken(), timeout]));
                if (disposed || failed)
                    return null;
                if (!token) {
                    expire('error');
                    return null;
                }
                return token;
            }
            catch {
                expire('error');
                return null;
            }
            finally {
                clearTimeout(timer);
                cancelRefresh = undefined;
            }
        },
        dispose() { disposed = true; proof = null; clearTimeout(timer); cancelRefresh?.(); },
    };
}
